import { useContext } from 'react';
import * as styledComponents from 'styled-components';

import normal, { FrismTheme } from './normal';

const {
  default: styled,
  css,
  ThemeProvider,
  createGlobalStyle,
} = styledComponents as unknown as styledComponents.ThemedStyledComponentsModule<FrismTheme>;

export function useTheme() {
  return useContext<FrismTheme>(styledComponents.ThemeContext);
}

export { css, ThemeProvider, createGlobalStyle, normal as normalTheme };

export * from './normal';
export default styled;
